var _path, _line, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 104,
    viewBox: "0 0 150 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 0C41.0868 0 14 27.5982 14 61.6424C14 78.0472 20.2895 92.9553 30.5457 104H118.454C128.711 92.9553 135 78.0472 135 61.6424C135 27.5982 107.913 0 74.5 0Z",
    fill: "#F8F8F8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 103,
    x2: 149,
    y2: 103,
    stroke: "#D9DBE3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1977_4069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 32,
    width: 34,
    height: 52,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 79.0167V82C57 83.1046 57.8954 84 59 84H91C92.1046 84 93 83.1046 93 82V74.7187M57 42.8049V34C57 32.8954 57.8954 32 59 32H91C92.1046 32 93 32.8954 93 34V70.6179",
    stroke: "#D9DBE3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9765 35.6114C57.9888 34.3744 59.1098 33.4451 60.3276 33.6623L82.3512 37.5903C83.3052 37.7605 84 38.5901 84 39.5592L84 86.8865C84 88.164 82.8187 89.114 81.5709 88.8399L59.087 83.9015C58.1623 83.6984 57.5067 82.8749 57.5161 81.9282L57.9765 35.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 55.9919V34.487C57 33.2095 58.1813 32.2595 59.4291 32.5335L83.0181 37.7147C83.9355 37.9162 84.589 38.7289 84.589 39.6681V87.513C84.589 88.7905 83.4077 89.7405 82.16 89.4665L58.5709 84.2853C57.6536 84.0839 57 83.2715 57 82.3322C57 78.7056 57 69.7197 57 63.4717M57 59.5842V60",
    stroke: "#D9DBE3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 61.5,
    width: 1,
    height: 4,
    rx: 0.5,
    fill: "white",
    stroke: "#D9DBE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1977_4069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(42 24)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.35d0cffd5e35edae3af7fb16575f1e97.svg";
export { ForwardRef as ReactComponent };